import React from 'react';
import { InlineMenu } from '@uncinc/uncinc-react-kitchen-sink';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Container from '../Container';

import './style.scss';

const VacancyNav = ({ childEntity }) => {
  const { t } = useTranslation();

  const generateMenuItems = () => {
    const items = [];
    const paragraphs = childEntity.get('field_vacancy_detail');

    // Intro items
    items.push({
      menuItemName: t('requirements'),
      elementId: 'vacancy-details',
      activeByDefault: true,
    });
    items.push({
      menuItemName: t('vacancy'),
      elementId: 'vacancy-body',
    });

    // Paragraph items
    paragraphs.map((paragraph, index) => {
      const linkName = paragraph.getIn(['entity', 'field_link_name', '0', 'value']);
      items.push({
        menuItemName: linkName,
        elementId: `paragraph--${index}`,
      });
    });

    return items;
  };

  return (
    <div className="VacancyNav">
      <Container>
        <Link
          onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth',
          })}
          to="/vacatures"
          className="VacancyNav__back-button icon-before icon-arrow_back"
        >
          Vacatures
        </Link>
        <InlineMenu
          items={generateMenuItems()}
          scrollToTopOffset={200}
        />
      </Container>
    </div>
  );
};

export default VacancyNav;
